import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenericService } from "../../generic.service";
import { PromoCode } from '../../../models/payment/promocode.model';
import { CreatePromocodeRequest, UpdatePromocodeRequest } from '../../../models/payment/promocodeRequests';

@Injectable({
  providedIn: 'root'
})
export class PromocodesService {
  constructor(private genericService: GenericService) {}

  getInitialPromocodes(): Observable<any> {
    return this.genericService.post('discounts', {});
  }

  getPromocodeById(id: any): Observable<any> {
    return this.genericService.get(`discount/${id}`);
  }

  searchPromocodeByCode(searchText: string): Observable<any> {
    return this.genericService.get(`discount/codes/${searchText}`);
  }

  validatePromocodeByCode(searchText: string): Observable<PromoCode> {
    return this.genericService.get(`discount/promocodes/validate/${searchText}`);
  }

  createPromocode(promocode: CreatePromocodeRequest): Observable<PromoCode> {
    return this.genericService.post<PromoCode>('discount', promocode);
  }

  updatePromocode(id: number, promocode: UpdatePromocodeRequest): Observable<PromoCode> {
    return this.genericService.put<PromoCode>(`discount/${id}`, promocode);
  }

  updatePromocodeStatus(id: number): Observable<any> {
    return this.genericService.put(`discount/status/${id}`, {});
  }
}